import { definePreset } from "@primeuix/themes";
import aura from "@primeuix/themes/aura";

export const CombinedPreset = definePreset(aura, {
  semantic: {
    primary: {
      100: '#e1e9f2',
      200: '#c2d0e6',
      300: '#9fb3d9',
      400: '#7a96cb',
      500: '#5c7dbf',
      600: '#485e8a',
      700: '#3e4f71',
      800: '#333f56',
      900: '#1f2123',
    },
    colorScheme: {
      dark: {
        primary: {
          color: '#1f2123',
          contrastColor: '#e1e9f2',
          hoverColor: '#333f56',
          activeColor: '#3e4f71'
        },
        surface: { // nello schema 'light' per il momento ho lasciato quelli di default
          0: "#212529",
          100: "#1a1a1a",
          200: "#222",
          300: "#333",
          400: "#444",
          500: "#555"
        },
        text: {
          color: "#ffffff"
        },
        formField: {
          background: '#1f1f1f',
          borderColor: '#404040',
          color: '#ffffff',
         
        }
      }
    }
  }
});
